import { Link } from 'react-router-dom';
import { Settings, Database, MessageSquare, DollarSign, Workflow } from 'lucide-react';

const IntegrationsPage = () => {
  const sections = [
    {
      title: 'SuccessWare',
      description: 'API credentials, operations catalog, field mappings, runner, and logs',
      icon: Settings,
      href: '/integrations/successware',
      color: 'blue'
    },
    {
      title: 'Booking Pipeline',
      description: 'ZIP routing, time windows, job defaults, and booking flow configuration',
      icon: Workflow,
      href: '/integrations/booking-pipeline',
      color: 'green'
    },
    {
      title: 'Payments',
      description: 'Stax/Stacks settings, diagnostic fee items, and invoice codes',
      icon: DollarSign,
      href: '/integrations/payments',
      color: 'yellow'
    },
    {
      title: 'Messaging',
      description: 'Twilio settings, SMS/voice/email templates, and notification rules',
      icon: MessageSquare,
      href: '/integrations/messaging',
      color: 'purple'
    },
    {
      title: 'Reference Cache',
      description: 'Job classes, types, departments, zones synced from SuccessWare',
      icon: Database,
      href: '/integrations/reference-cache',
      color: 'indigo'
    }
  ];

  const colorClasses: Record<string, string> = {
    blue: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    green: 'bg-green-500/10 text-green-400 border-green-500/20',
    yellow: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
    purple: 'bg-purple-500/10 text-purple-400 border-purple-500/20',
    indigo: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20'
  };

  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Integrations</h1>
        <p className="text-slate-400">
          Manage API connections, field mappings, and external service configurations
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <Link
              key={section.href}
              to={section.href}
              className="block p-6 bg-slate-900 border border-slate-800 rounded-lg hover:border-slate-700 transition-all group"
            >
              <div className={`inline-flex p-3 rounded-lg border ${colorClasses[section.color]} mb-4`}>
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-blue-400 transition-colors">
                {section.title}
              </h3>
              <p className="text-slate-400 text-sm">
                {section.description}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default IntegrationsPage;
